import React, { useState } from 'react';
import Login from './Login';
import Register from './Register';
import ForgetPassword from './ForgetPassword';

function MyAccount() {
  const sectionName = 'Account';
  const [currentForm, setCurrentForm] = useState('login');

  const toggleForm = (formType) => {
    setCurrentForm(formType);
  };

  return (
    <div className='container p-4'>
      <div className='row d-flex justify-content-center align-items-center'>
        <div className='col-md-6'>
          <div className='formContainer'>
            {currentForm === 'login' && (
              <Login toggleForm={toggleForm} sectionName={sectionName} />
            )}
            {currentForm === 'register' && <Register toggleForm={toggleForm} />}
            {currentForm === 'forgetPassword' && (
              <ForgetPassword toggleForm={toggleForm} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyAccount;
